/** Millrace materials: honey timber, wet slate, oxidised copper, cream flour, green moss and river water.
 * Legacy clothBlue role names remain wire-compatible; Millrace fills them with warm linen, never blue cloth.
 */
import type { ResolvedPalette } from './contract';
export const MILLRACE_PALETTES = {
  millrace_amber: {
    outline: '#25362f', outlineSoft: '#657369', paperBase: '#ce945c', paperLight: '#f4e7c8', paperShadow: '#8b5b3c',
    warmCore: '#ffe2a0', woodBase: '#a67843', woodLight: '#d1a365', woodShadow: '#593e2d',
    clothBlue: '#bca579', clothBlueLight: '#eddfb7', clothBlueShadow: '#806847',
    reedBase: '#71854d', reedLight: '#b1ad63', reedShadow: '#415b39',
    stoneBase: '#697871', stoneLight: '#a8b0a1', stoneShadow: '#3c504b', moss: '#5f8245', salt: '#e7e2c8',
    waterFar: '#376d66', waterLight: '#99c4b2',
  },
  millrace_spray: {
    outline: '#253c38', outlineSoft: '#637d72', paperBase: '#a77d53', paperLight: '#eee4ce', paperShadow: '#72563f',
    warmCore: '#f8d99d', woodBase: '#8f704e', woodLight: '#bea17b', woodShadow: '#4c4132',
    clothBlue: '#b9a883', clothBlueLight: '#e9dfc4', clothBlueShadow: '#807153',
    reedBase: '#5e8361', reedLight: '#a6b88d', reedShadow: '#365d49',
    stoneBase: '#657f79', stoneLight: '#a6bab0', stoneShadow: '#354f4a', moss: '#47775a', salt: '#e4e8d7',
    waterFar: '#2d605e', waterLight: '#a9d9ce',
  },
} as const satisfies Record<string, ResolvedPalette>;
